const sortLogsNewestFirst = (logs) =>
  [...logs].sort((a, b) => new Date(b.created_at || 0) - new Date(a.created_at || 0));

const getLastApprovedAuditLog = (auditLogs) => {
  if (!auditLogs?.length) {
    return null;
  }
  const approvedLogs = auditLogs.filter(
    (log) =>
      (log.action_code || '').toUpperCase() === 'APPROVED' &&
      (log.performed_by_role || '').toUpperCase() !== 'SYSTEM'
  );
  return approvedLogs.length ? sortLogsNewestFirst(approvedLogs)[0] : null;
};

export const getPreviousApproverEmailFromAuditLogs = (auditLogs) => {
  const lastApproved = getLastApprovedAuditLog(auditLogs);
  return lastApproved?.performed_by_email?.trim() || '';
};

export const getPreviousApproverNameFromAuditLogs = (auditLogs) => {
  const lastApproved = getLastApprovedAuditLog(auditLogs);
  const role = (lastApproved?.performed_by_role || '').trim();
  if (role && role.toUpperCase() !== 'SYSTEM' && role.toUpperCase() !== 'USER') {
    return role;
  }
  return (lastApproved?.performed_by_username || '').trim();
};

export const getCurrentApproverEmail = (auditLogs, currentRoleName, invoicePayload) => {
  const directEmail =
    invoicePayload?.assigned_role?.email ||
    invoicePayload?.assigned_role?.user_email ||
    invoicePayload?.assigned_user_email ||
    '';
  if (directEmail) {
    return String(directEmail).trim();
  }

  const role = (currentRoleName || '').trim();
  if (!role || !auditLogs?.length) {
    return '';
  }

  const assignmentActions = new Set(['ASSIGNED', 'FORWARDED', 'FORWARD', 'APPROVED']);

  for (const log of sortLogsNewestFirst(auditLogs)) {
    const actionCode = (log.action_code || '').toUpperCase();
    if (!assignmentActions.has(actionCode)) {
      continue;
    }

    const targetRole = (
      log.assigned_role?.name ||
      log.action_details?.new_role_name ||
      log.action_details?.assigned_to_role_name ||
      ''
    ).trim();

    if (targetRole !== role) {
      continue;
    }

    const email =
      log.assigned_to_email ||
      log.action_details?.assigned_to_email ||
      log.assigned_role?.email ||
      log.assigned_role?.user_email ||
      '';
    if (email) {
      return String(email).trim();
    }
  }

  return '';
};
